import { render, staticRenderFns } from "./ReportingPostTypes.vue?vue&type=template&id=f81ec73c&scoped=true"
import script from "./ReportingPostTypes.vue?vue&type=script&lang=js"
export * from "./ReportingPostTypes.vue?vue&type=script&lang=js"
import style0 from "./ReportingPostTypes.vue?vue&type=style&index=0&id=f81ec73c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81ec73c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81ec73c')) {
      api.createRecord('f81ec73c', component.options)
    } else {
      api.reload('f81ec73c', component.options)
    }
    module.hot.accept("./ReportingPostTypes.vue?vue&type=template&id=f81ec73c&scoped=true", function () {
      api.rerender('f81ec73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingPostTypes.vue"
export default component.exports